// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '../../../../Utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
import { type PFixFieldSet } from '../Fields/PFixFieldSet';

export class PortfolioStatisticsRequest extends PFixMessage {
    constructor (fieldSet?: PFixFieldSet) {
        super(Message.CODE_PFIX_PORTFOLIO_STATISTICS_REQUEST, fieldSet);
    }

    public setAccountId (accountId: number): void {
        this.setFieldValue(FieldsFactory.FIELD_ACCOUNT_ID, accountId);
    }

    public setType (type): void {
        this.setFieldValue(FieldsFactory.FIELD_TYPE, type);
    }

    public setStartTime (startTime: Date | null): void {
        if (startTime) {
            this.setFieldValue(FieldsFactory.FIELD_START_TIME, startTime);
        }
    }

    public setEndTime (endTime: Date | null): void {
        if (endTime) {
            this.setFieldValue(FieldsFactory.FIELD_END_TIME, endTime);
        }
    }

    public setRouteId (routeId: number | null): void {
        if (routeId) {
            this.setFieldValue(FieldsFactory.FIELD_ROUTE_ID, routeId);
        }
    }

    public setInstrumentTradableId (instrumentTradableId: number | null): void {
        if (instrumentTradableId) {
            this.setFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, instrumentTradableId);
        }
    }
}
